import React from 'react'
import {Form} from "@redriver/cinnamon";

const NonPropagatingTypeAhead = (props) => {
    return (
        <Form.TypeAhead {...props} onKeyDown={(e) => e.stopPropagation()}/>
    )
}
export default NonPropagatingTypeAhead
